import { render } from "./SimpleCode.vue?vue&type=template&id=172488ce&style=display%3A%20inline-block"
import script from "./SimpleCode.vue?vue&type=script&lang=js"
export * from "./SimpleCode.vue?vue&type=script&lang=js"

import "./SimpleCode.vue?vue&type=style&index=0&id=172488ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__